import { authHttp } from '../http'
import * as routes from '../../routes/cte.routes'
import { errorHandler } from '../../../util/error.service'

export async function getEmissores() {
  try {
    const response = await authHttp().get(routes.urlEmissores)
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function getEmissoresByTps(tps_ids) {
  try {
    const response = await authHttp().get(routes.urlGetEmissoresTpId(tps_ids))
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function saveEmissor({ id, ...body }) {
  try {
    const response = id
      ? await authHttp().put(`${routes.urlEmissores}/${id}`, body)
      : await authHttp().post(routes.urlEmissores, body)
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function updateUltimoEmitido(id, ultimo_emitido) {
  try {
    const response = await authHttp().patch(`${routes.urlEmissores}/${id}/ultimo-emitido`, { ultimo_emitido })
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function getCertificadoEmissor(id) {
  try {
    const response = await authHttp().get(`${routes.urlEmissores}/${id}/certificado`)
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function saveCertificadoEmissor(id, arquivo, senha) {
  try {
    const form = new FormData()
    form.append('arquivo', arquivo)
    form.append('senha', senha)
    const response = await authHttp().put(`${routes.urlEmissores}/${id}/certificado`, form)
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}
